"use client";

import { useRouter } from "next/navigation";
import { useState, type FormEvent } from "react";

export function RegisterForm() {
	const router = useRouter();
	const [error, set_error] = useState("");

	async function on_submit(event: FormEvent<HTMLFormElement>) {
		event.preventDefault();
		const form = new FormData(event.currentTarget);
		const body = Object.fromEntries(form.entries());
		const response = await fetch("/api/v1/auth/register", {
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify(body),
		});
		const json = await response.json();
		if (!response.ok) {
			set_error(json?.error?.message ?? "Registrierung fehlgeschlagen.");
			return;
		}

		const login = await fetch("/api/v1/auth/login", {
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify({ email: body.email, password: body.password }),
		});
		if (!login.ok) {
			set_error("Konto angelegt, Anmeldung fehlgeschlagen. Bitte manuell anmelden.");
			return;
		}

		router.push("/app");
		router.refresh();
	}

	return (
		<form className="stack" onSubmit={on_submit}>
			{error ? <div className="flash-error">{error}</div> : null}
			<label>Unternehmen<input name="company_name" required /></label>
			<label>Vorname<input name="first_name" required /></label>
			<label>Nachname<input name="last_name" required /></label>
			<label>E-Mail<input name="email" type="email" required /></label>
			<label>Passwort<input name="password" type="password" minLength={8} required /></label>
			<button type="submit">Unternehmen anlegen</button>
		</form>
	);
}
